import { useEffect, useState } from 'react'
import { useAppContext } from '../../context/AppContext'
import axios from 'axios'
import { formatDate } from '../../util/FormatDate';
import { useNavigate } from 'react-router-dom';
import api from '../../api';

const Customerlist = () => {
  const { user, axiUrl } = useAppContext();
  const [customers, setCustomers] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newCompany, setNewCompany] = useState({
    name: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    adminemail: '',
    adminname: '',
    plan: '',
    dba:''
  });
  const nav = useNavigate();

  useEffect(() => {
    const getcustomers = async () => {
      const response = await api.post('/user/getcustomers')
        .then(res => {
          console.log(res.message);
          setCustomers(res.data.companies);
        })
        .catch(err => console.log(err));
    };
    getcustomers();
  }, []);

  const getprocessed = () => {
    let resp = axios.post(`${axiUrl}/jobs/getjobsbycustomer`, { id: user.company?._id })
      .then(res => {
        setJobs(res.data.message);
      })
      .catch(err => console.log(err));
  };

  console.log(customers);

  // Filter customers based on search term
  const filteredCustomers = customers?.filter(cust =>
    cust?.name?.toLowerCase().includes(searchTerm.toLowerCase()) || cust?.admin?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleNewCompanyChange = (e) => {
    const { name, value } = e.target;
    setNewCompany({ ...newCompany, [name]: value });
  };

  const handleNewCompanySubmit = async (e) => {
    e.preventDefault();
    // if (!newCompany.name || !newCompany.adminemail)  // Basic validation

    console.log(newCompany)
    try {
      const response = await api.post('/company/addcompany', newCompany);
      console.log(response.data)
     // setCustomers([...customers, response.data.company]);
     // setNewCompany({ name: '', address: '', city: '', state: '', zip: '', admin: '', plan: '',adminemail: '', adminnname:''  });
     // setIsModalOpen(false);
  //  nav(`/dashboard/customer/${response.data._id}`);
    } catch (err) {
      console.error('Error creating company:', err);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md max-h-[70vh] min-h-[70vh] overflow-y-auto">
      <h1 className='mb-20'>Companies - {customers?.length}</h1>
      <div className="flex items-center mb-3 gap-2">
        <div className='flex-1'>
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-[90%] px-2 py-1 rounded border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white text-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className='flex flex-1 justify-end'>
          <button
            className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600 text-md"
            onClick={() => setIsModalOpen(true)}
          >
            New Company
          </button>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-left text-md text-gray-700 dark:text-gray-200 cursor-pointer">
          <thead>
            <tr className="border-b dark:border-gray-700">
              <th className="py-1.5 px-3">Company</th>
              <th className="py-1.5 px-3">Address</th>
              <th className="py-1.5 px-3">Verified</th>
              <th className="py-1.5 px-3"></th>
              <th className="py-1.5 px-3">Admin</th>
              <th className="py-1.5 px-3">Orders</th>
              <th className="py-1.5 px-3 w-48">Plan</th>
            </tr>
          </thead>
          <tbody>
            {filteredCustomers?.map(cust => (
              <tr
                key={cust?._id}
                className="border-b dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700"
              
                onClick={() => nav(`/dashboard/customer/${cust?._id}`)}
              >
                <td className="py-1.5 px-3"   style={{color:cust.status ? 'inherit' :'rgb(255,0,0,.7)',fontWeight:cust.status ? 'normal' :'bold' }}>{cust?.name}</td>
                <td className="py-1.5 px-3">{cust?.address} {cust?.address} {cust?.city}, {cust?.state} {cust?.zip}</td>
                <td className="py-1.5 px-3">{formatDate(cust.createdAt)}</td>
                <td className="py-1.5 px-3"></td>
                <td className="py-1.5 px-3">{cust?.admin}</td>
                <td className="py-1.5 px-3">16</td>
                <td className="py-1.5 px-3 font-bold w-48">{cust?.plan}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* New Company Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50" style={{background:'rgb(0,0,0,.7)'}}>
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-[800px]">
            <h2 className="text-xl font-semibold text-gray-700 dark:text-gray-200 mb-4">Add New Company</h2>
            <h4 className='mb-4'>All Fields Required</h4>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-600 dark:text-gray-300">Company Name</label>
                <input
                  type="text"
                  name="name"
                  value={newCompany.name}
                  onChange={handleNewCompanyChange}
                  className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  placeholder="Enter company name"
                />
              </div>
                 <div>
                <label className="block text-sm font-medium text-gray-600 dark:text-gray-300">DBA</label>
                <input
                  type="text"
                  name="dba"
                  value={newCompany.dba}
                  onChange={handleNewCompanyChange}
                  className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  placeholder="Enter DBA"
                />
              </div>
              </div> 
               <div className="grid grid-cols-2 gap-4 pt-[15px]">
              <div>
                <label className="block text-sm font-medium text-gray-600 dark:text-gray-300">Address</label>
                <input
                  type="text"
                  name="address1"
                  value={newCompany.address}
                  onChange={handleNewCompanyChange}
                  className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  placeholder="Enter address"
                />
              </div>
               <div>
                <label className="block text-sm font-medium text-gray-600 dark:text-gray-300">Address 2</label>
                <input
                  type="text"
                  name="address2"
                  value={newCompany.address2}
                  onChange={handleNewCompanyChange}
                  className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  placeholder="Enter Address 2"
                />
              </div>
              </div>
                <div className="grid grid-cols-3 gap-4 pt-[15px]">
              <div>
                <label className="block text-sm font-medium text-gray-600 dark:text-gray-300">City</label>
                <input
                  type="text"
                  name="city"
                  value={newCompany.city}
                  onChange={handleNewCompanyChange}
                  className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  placeholder="Enter city"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 dark:text-gray-300">State</label>
                <input
                  type="text"
                  name="state"
                  value={newCompany.state}
                  onChange={handleNewCompanyChange}
                  className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  placeholder="Enter state"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 dark:text-gray-300">Zip Code</label>
                <input
                  type="text"
                  name="zip"
                  value={newCompany.zip}
                  onChange={handleNewCompanyChange}
                  className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  placeholder="Enter zip code"
                />
              </div>
              </div>
                <div className="grid grid-cols-2 gap-4 pt-[15px]">
                        <div>
                <label className="block text-sm font-medium text-gray-600 dark:text-gray-300">Admin Name</label>
                <input
                  type="text"
                  name="adminname"
                  value={newCompany.adminname}
                  onChange={handleNewCompanyChange}
                  className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  placeholder="Enter Admin Name"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 dark:text-gray-300">Admin Email</label>
                <input
                  type="text"
                  name="adminemail"
                  value={newCompany.adminemail}
                  onChange={handleNewCompanyChange}
                  className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  placeholder="Enter Admin Email"
                />
              </div>
           
              </div>
               <div className="grid grid-cols-2 gap-4 pt-[15px]">
                <div></div>
              <div>
                <label className="block text-sm font-medium text-gray-600 dark:text-gray-300">Plan</label>
                <select
                  name="plan"
                  value={newCompany.plan}
                  onChange={handleNewCompanyChange}
                  className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                >
                  <option value="">Select a Plan</option>
                  <option value="Basic">Basic</option>
                  <option value="Premium">Premium</option>
                  <option value="Enterprise">Enterprise</option>
                </select>
              </div>
            </div>
              <div className="grid grid-cols-2 gap-4 pt-[15px]">
                <div></div>
              <div>
                <label className="block text-sm font-medium text-gray-600 dark:text-gray-300">Status</label>
                <select
                  name="status"
                  value={newCompany.status}
                  onChange={handleNewCompanyChange}
                  className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                >
                  <option value="">Select a Status</option>
                  <option value="false">Inactive</option>
                  <option value='true'>Active</option>
                  
                </select>
              </div>
            </div>
            <div className="mt-6 flex space-x-3">
              <button
                onClick={handleNewCompanySubmit}
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
              >
                Create Company
              </button>
              <button
                onClick={() => {
                  setNewCompany({ name: '', address: '', city: '', state: '', zip: '', admin: '', plan: '' });
                  setIsModalOpen(false);
                }}
                className="px-4 py-2 bg-gray-300 text-gray-700 dark:bg-gray-600 dark:text-gray-200 rounded-md hover:bg-gray-400 dark:hover:bg-gray-500 transition"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Customerlist;